export enum BudgetServiceType {
  PREVENTIVE = 'PREVENTIVE',
  PLAN = 'PLAN',
  CORRECTIVE = 'CORRECTIVE',
  OTHER = 'OTHER',
}
